"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECTED_ITEM_LAYER_TRANSITIONS_PROPS = exports.ALL_TECHNOLOGIES_TRANSITIONS_PROPS = void 0;
exports.ALL_TECHNOLOGIES_TRANSITIONS_PROPS = {
    initial: {
        opacity: 0,
        y: '20px'
    },
    animate: {
        opacity: 1,
        y: 0
    },
    exit: {
        opacity: 0,
        y: '20px'
    }
};
exports.SELECTED_ITEM_LAYER_TRANSITIONS_PROPS = {
    initial: {
        opacity: 0,
        x: '-100%'
    },
    animate: {
        opacity: 1,
        x: 0
    },
    exit: {
        opacity: 0,
        x: '100%'
    }
};
